<div class="container-fluid pl-0 pt-3">
    <div class="col-md-6 w-100 pr-0">

        <div class="d-flex justify-content-between ">
            <div class="header-infos ">
                <p class="m-0 text-uppercase" style="font-size: 20px; color: #262756;font-weight: bold;">Conducteurs</p>
                <small class="text-uppercase" style="font-size:15px;color: #707070;">Statistiques des conducteurs </small>
            </div>
            <div style="width: 47%">
                <mat-form-field appearance="fill">
                    <!-- <mat-label>Filtrer par date Début-Fin</mat-label> -->
                    <mat-date-range-input [formGroup]="rangeForm" [min]="minDate" [max]="maxDate"
                        [rangePicker]="picker2">
                        <input formControlName="start" autocomplete="off" readonly matStartDate
                            placeholder="Date Début">
                        <input formControlName="end" autocomplete="off" readonly matEndDate placeholder="End date"
                            (dateChange)="addNewDate(rangeForm )">
                    </mat-date-range-input>
                    <mat-datepicker-toggle matSuffix [for]="picker2" placement="bottom" ngbTooltip="Date Fin">
                    </mat-datepicker-toggle>
                    <!-- maxRange=29 -->
                    <mat-date-range-picker
                     #picker2></mat-date-range-picker>
                </mat-form-field>
            </div>
        </div>

    </div>

    <div class="col-lg-6 col-xl-3 col-md-6 mb-3 w-100">

    </div>

    <ngx-spinner bdColor="rgba(100,112,124,0.56)" size="medium" color="#233547" type="ball-clip-rotate-multiple"
        [fullScreen]="true">
        <p style="color: white"> </p>
    </ngx-spinner>
    <div class="row rowposition  px-0">
        <div class=" col-lg-6 col-xl-3 col-md-6 w-100 pr-0">

            <!--  <div class="p-3 mb-2 headerZoom"
                style="height:72px !important; background: #323d415c;box-shadow: 5.9px 6.8px 15.5px rgba(137, 148, 169, 0.28), -2.8px -2.8px 8px white, inset 3.5px 3.5px 6px rgba(255, 255, 255, 0.15);border-radius: 6px">
                <div class="col-3 col-md-12 w-100">
                    <div class="row">

                        <div class="col-6 col-md-2 w-100">
                            <div style="
              cursor: pointer;
              border-radius: 7px;

              display: flex;
              justify-content: center;

            " class="py-1">
                                <img (click)="exportExcel(exportDirective, 'xlsx')"
                                    src="https://img.icons8.com/color/40/000000/export-excel.png" />


                            </div>
                        </div>
                        <div class="col-6 col-md-3 w-100">
                            <div style="
              cursor: pointer;
              border-radius: 7px;

              display: flex;
              justify-content: center;

            " class="py-1">
                                <img (click)="exportExcel(exportDirective, 'csv')"
                                    src="https://img.icons8.com/color/40/000000/export-csv.png" />

                            </div>
                        </div>
                        <div class="col-6 col-md-2 w-100">
                            <div style="
              cursor: pointer;
              border-radius: 7px;

              display: flex;
              justify-content: center;

            " class="py-1">

                                <img (click)="exportExcel(exportDirective, 'json')"
                                    src="https://img.icons8.com/color/40/000000/json-download.png" />

                            </div>
                        </div>
                        <div class="col-6 col-md-3 w-100">
                            <div style="
              cursor: pointer;
              border-radius: 7px;

              display: flex;
              justify-content: center;

            " class="py-1">

                                <img (click)="exportExcel(exportDirective, 'txt')"
                                    src="https://img.icons8.com/color/40/000000/rich-text-converter.png" />
                            </div>
                        </div>
                        <div class="col-6 col-md-2 w-100">
                            <div style="
              cursor: pointer;
              border-radius: 7px;

              display: flex;
              justify-content: center;

            " class="py-1">
                                <img (click)="exportTable()"
                                    src="https://img.icons8.com/color/40/000000/export-pdf.png" />

                            </div>
                        </div>

                    </div>


                </div>

            </div>

            <div class="p-3 mb-2 headerZoom"
                style="zoom:0.9;    display: flex;
                             align-items: center;height:80px !important;background: #323d415c;box-shadow: 5.9px 6.8px 15.5px rgba(137, 148, 169, 0.28), -2.8px -2.8px 8px white, inset 3.5px 3.5px 6px rgba(255, 255, 255, 0.15);border-radius: 6px">
                <div class="col-lg-12 col-xl-12 col-md-12 w-100">
                    <div class="row">





                        <mat-chip-list>

                            <mat-chip style="background: #1f1f20; color: #ffffff" selected (click)="getFilterChoise(1)">
                                1 jour
                            </mat-chip>


                            <mat-chip selected style="background: #fdd512; color: #ffffff" (click)="getFilterChoise(7)">
                                7
                                jours</mat-chip>


                            <mat-chip selected style="background: #237dbd; color: #ffffff"
                                (click)="getFilterChoise(14)">2
                                semaines
                            </mat-chip>


                            <mat-chip color="primary" selected (click)="getFilterChoise(30)">1 mois</mat-chip>
                        </mat-chip-list>

                    </div>
                </div>
            </div> -->

            <div class="export-icons d-flex mb-2">
                <div class="icn-sec">
                    <img (click)="exportExcel(exportDirective, 'xlsx')" src="assets/newImages/excel-svg.svg" />
                </div>
                <div class="icn-sec">
                    <img (click)="exportTable()" src="assets/newImages/pdf-svg.svg" />
                </div>
            </div>
        </div>
        <div class="col-lg-6 col-xl-3 mb-2 col-md-6 w-100 px-0">


            <div class="col-12 col-md-12 w-100 ">
                <div class="container-fluid ">
                    <div class="row rowposition px-0 pt-0" style="max-height: 182px;">


                        <div class="col-6">
                            <div class="score-item">
                                <img class="safety_Score" alt="" placement="bottom" ngbTooltip="Score de sécurité"
                                    src="assets/newImages/security-svg.svg" />
                                <div class="chart-infos">
                                    <div class="d-flex justify-content-center mt-1">
                                        <h4>{{scoreS}}%</h4>

                                        <mat-icon class="mt-2" style="color: #262756;" *ngIf="(sc_tnd_sec == 1 )">
                                            arrow_upward </mat-icon>

                                        <mat-icon class="mt-2" style="color: #262756;" *ngIf="(sc_tnd_sec == 0 )">
                                            arrow_forward</mat-icon>

                                        <mat-icon class="mt-2" style="color: #262756;" *ngIf="(sc_tnd_sec == -1 )">
                                            arrow_downward </mat-icon>
                                    </div>
                                </div>
                                <div class="chart-unit">
                                    <h5>{{distanceEntreMan}}Km <span>Entre les risques</span></h5>
                                </div>
                            </div>
                        </div>

                        <div class="col-6">
                            <div class="score-item">
                                <img class="safety_score" alt="" placement="bottom" ngbTooltip="Score d'économie"
                                    src="assets/newImages/tree.svg" />
                                <div class="chart-infos">
                                    <div class="d-flex justify-content-center mt-1">
                                        <h4>{{scoreEc}}%</h4>
                                        <mat-icon class="mt-2" style="color: #262756;" *ngIf="(sc_tnd_eco == 1 )">
                                            arrow_upward </mat-icon>

                                        <mat-icon class="mt-2" style="color: #262756;" *ngIf="(sc_tnd_eco == 0 )">
                                            arrow_forward</mat-icon>

                                        <mat-icon class="mt-2" style="color: #262756;" *ngIf="(sc_tnd_eco == -1 )">
                                            arrow_downward </mat-icon>
                                    </div>
                                </div>
                                <div class="chart-unit">
                                    <h5>{{tmpinactivite}}% <span>inactivité moyenne</span></h5>
                                </div>
                            </div>
                        </div>







                    </div>


                </div>

            </div>

        </div>


        <div class="col-lg-12 col-xl-6 col-md-12">

            <div class="row">

                <div class="col-6 col-md-6 w-100 px-0" style="    display: flex;
                    justify-content: right;  max-height: 160px !important; ">
                    <ngx-charts-gauge
                        style="background-color: white;fill: #51b373;box-shadow: 10px 10px 15px #00000008;border-radius: 6px;"
                        [view]="view" [scheme]="colorSchemeDist" [results]="singleDistance" [legend]="legendDist"
                        [legendPosition]="legendPositionDist" [min]="minDist" [max]="maxDist" [units]="unitsDist"
                        [smallSegments]="0" [bigSegments]="2" [valueFormatting]="formatDist" [angleSpan]="angleSpan"
                        [startAngle]="startAngle">
                    </ngx-charts-gauge>

                </div>

                <div class="col-6 col-md-6 w-100 px-0" style="    display: flex;
              justify-content: center; max-height: 160px !important;">

                    <ngx-charts-gauge
                        style="background-color: white;fill: #FBB950;box-shadow: 10px 10px 15px #00000008;border-radius: 6px;"
                        [view]="view" [scheme]="colorSchemeVitesse" [results]="singleVitesse" [legend]="legendVitesse"
                        [legendPosition]="legendPositionVitesse" [min]="minVitesse" [max]="maxVitesse"
                        [units]="unitsVitesse" [smallSegments]="0" [bigSegments]="2" [valueFormatting]="formatVitesse"
                        [angleSpan]="angleSpan" [startAngle]="startAngle">
                    </ngx-charts-gauge>


                </div>


            </div>
        </div>
        <hr class="w-100">
        <div class="col-xl-2">
            <mat-form-field appearance="fill">
              <mat-label>Filtrer par</mat-label>
              <mat-select>
                  <mat-option selected (click)="getFilterChoise(1)" [value]="'1 Jour'">
                      1 Jour
                  </mat-option>
                  <mat-option selected (click)="getFilterChoise(7)" [value]="'7 Jours'">
                    7 Jours
                </mat-option>
                <mat-option  selected (click)="getFilterChoise(14)" [value]="'2 Semaines'">
                    2 Semaines
                </mat-option>
                <mat-option selected (click)="getFilterChoise(30)" [value]="'1 Mois'">
                    1 Mois
                </mat-option>
                <mat-option selected (click)="getFilterChoise(180)" [value]="'6 Mois'">
                    6 Mois
                </mat-option>
                <mat-option selected (click)="getFilterChoise(360)" [value]="'1 Ans'">
                    1 An
                </mat-option>
              </mat-select>

          </mat-form-field>
          </div>
        <div class="col-lg-6 col-xl-1 col-md-6 w-100 mb-4">
            <mat-form-field appearance="fill">
                <mat-label>Page</mat-label>
                <mat-select>
                    <mat-option *ngFor="let item of collection" (click)="updateManualPage(item - 1)" [value]="item">
                        {{ item }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div class="col-lg-6 col-xl-1 col-md-6 w-100 mb-4">
            <mat-form-field appearance="fill">
                <mat-label>Eléments</mat-label>

                <mat-select [(ngModel)]="pageSize">
                    <mat-option (click)="updateManualPage2(pageSize)" *ngFor="let pageSize of pageSizeOptions"
                        [value]="pageSize">
                        {{ pageSize }}</mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div class="col-lg-12 col-xl-5 col-md-12 w-100 mb-4">
        </div>
        <div class="col-lg-6 col-xl-3 col-md-6 w-100 mb-4">

            <form>
                <mat-form-field appearance="fill">
                    <mat-label>Filtrer par conducteur</mat-label>

                    <input type="text" aria-label="Number" (keyup)="applyFilterer($event)" matInput
                        [formControl]="myControl" #input id="getdt" name="getdt" value="{{ itemSelect2 }}" />

                    <button mat-button matSuffix mat-icon-button>
                        <mat-icon placement="left" ngbTooltip="Actualiser les données des vehicules"
                            (click)="getUserrefrech()">update</mat-icon>

                    </button>




                </mat-form-field>
            </form>
        </div>

        <div style="visibility: hidden; position: fixed" [style.left]="contextMenuPosition.x"
            [style.top]="contextMenuPosition.y" [matMenuTriggerFor]="contextMenu">
        </div>
        <mat-menu #contextMenu="matMenu">
            <ng-template matMenuContent let-item="item">
                <button mat-menu-item (click)="dbClickitem(item.id)"><i class="fas fa-info-circle" style="color: #262756;"></i> Accéder aux
                    détails </button>



            </ng-template>
        </mat-menu>



        <div class="col-12 col-md-12 w-100">
            <div class=" example-container mat-elevation-z8 " [ngClass]="{hiddenContenuTbls: tblhidden == 'true' ,
                        hiddenContenuTbls2 : tblhidden != 'true' }">


                <table id="ExampleTable" class="table-hover" #exportDirective="matTableExporter" matTableExporter
                    mat-table [dataSource]="dataSource" matSort>
                    <!-- ID Column -->
                    <ng-container matColumnDef="name">
                        <th mat-header-cell mat-sort-header *matHeaderCellDef>
                            Nom
                        </th>
                        <td mat-cell *matCellDef="let row" [ngClass]="{ highlight: selectedRowIndex == row.id }"
                            (click)="getItemDetails(row)" (contextmenu)="onContextMenu($event, row)">
                            {{ row.name }}
                        </td>
                    </ng-container>





                    <!-- Progress Column -->
                    <ng-container matColumnDef="distance_traveled">
                        <th mat-header-cell mat-sort-header *matHeaderCellDef>
                            Distance
                        </th>
                        <td mat-cell *matCellDef="let row" [ngClass]="{ highlight: selectedRowIndex == row.id }"
                            (click)="getItemDetails(row)" (contextmenu)="onContextMenu($event, row)">
                            {{ row.distance_traveled }} Km
                        </td>
                    </ng-container>
                    <!-- Name Column -->
                    <ng-container matColumnDef="trip_duration">
                        <th mat-header-cell mat-sort-header *matHeaderCellDef>
                            Durée
                        </th>
                        <td mat-cell *matCellDef="let row" [ngClass]="{ highlight: selectedRowIndex == row.id }"
                            (click)="getItemDetails(row)" (contextmenu)="onContextMenu($event, row)">
                            {{ row.trip_duration | formatTime}}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="avg_distance">
                        <th mat-header-cell mat-sort-header *matHeaderCellDef>
                            Distance moy. (km)
                        </th>
                        <td mat-cell *matCellDef="let row" [ngClass]="{ highlight: selectedRowIndex == row.id }"
                            (click)="getItemDetails(row)" (contextmenu)="onContextMenu($event, row)">
                            {{ row.avg_distance}} Km

                        </td>
                    </ng-container>

                    <ng-container matColumnDef="avg_speed">
                        <th mat-header-cell mat-sort-header *matHeaderCellDef>
                            Vitesse moy. (km/h)
                        </th>
                        <td mat-cell *matCellDef="let row" [ngClass]="{ highlight: selectedRowIndex == row.id }"
                            (click)="getItemDetails(row)" (contextmenu)="onContextMenu($event, row)">
                            {{ row.avg_speed}} km/h
                        </td>
                    </ng-container>
                    <!-- Progress Column -->
                    <ng-container matColumnDef="safety_score">
                        <th mat-header-cell mat-sort-header *matHeaderCellDef>
                            Score de sécurité
                        </th>
                        <td mat-cell *matCellDef="let row" [ngClass]="{ highlight: selectedRowIndex == row.id }"
                            (click)="getItemDetails(row)" (contextmenu)="onContextMenu($event, row)">
                            <circle-progress [percent]="row.safety_score" [showSubtitle]=false [radius]="25"
                                [outerStrokeWidth]="2" [innerStrokeWidth]="1"
                                [outerStrokeColor]="updateColor(row.safety_score)"
                                [innerStrokeColor]="updateColor(row.safety_score)" [animation]="false"
                                [animationDuration]="1" [titleFontSize]="18"></circle-progress>


                        </td>
                    </ng-container>
                    <ng-container matColumnDef="safety_score_tendency">
                        <th mat-header-cell mat-sort-header *matHeaderCellDef>
                            Tendance de sécurité
                        </th>
                        <td mat-cell *matCellDef="let row" [ngClass]="{ highlight: selectedRowIndex == row.id }"
                            (click)="getItemDetails(row)">

                            <mat-icon style="color: #4ca846b5;" *ngIf="(row.safety_score_tendency == 1)">
                                arrow_upward </mat-icon>

                            <mat-icon style="color: #237dbdb0;" *ngIf="(row.safety_score_tendency == 0)">
                                arrow_forward</mat-icon>

                            <mat-icon style="color: #e15b6b;" *ngIf="(row.safety_score_tendency == -1 )">
                                arrow_downward </mat-icon>

                        </td>
                    </ng-container>
                    <ng-container matColumnDef="tendance_securite_mensuelle">
                        <th mat-header-cell mat-sort-header *matHeaderCellDef>
                            Tendance de sécurité mensuelle
                        </th>
                        <td mat-cell *matCellDef="let row" [ngClass]="{ highlight: selectedRowIndex == row.id }"
                            (click)="getItemDetails(row)" (contextmenu)="onContextMenu($event, row)">
                            {{ row.open_issues }}%
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="diff_safety_score">
                        <th mat-header-cell mat-sort-header *matHeaderCellDef>
                            Diff. de sécurité
                        </th>
                        <td mat-cell *matCellDef="let row" [ngClass]="{ highlight: selectedRowIndex == row.id }"
                            (click)="getItemDetails(row)" (contextmenu)="onContextMenu($event, row)">
                            {{ row.diff_safety_score}}

                        </td>
                    </ng-container>


                    <ng-container matColumnDef="km_between_maneuvers">
                        <th mat-header-cell mat-sort-header *matHeaderCellDef>
                            Km entre les risques
                        </th>
                        <td mat-cell *matCellDef="let row" [ngClass]="{ highlight: selectedRowIndex == row.id }"
                            (click)="getItemDetails(row)" (contextmenu)="onContextMenu($event, row)">
                            {{ row.km_between_maneuvers}} km
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="nb_maneuvers">
                        <th mat-header-cell mat-sort-header *matHeaderCellDef>
                            Nb manoeuvres risquées
                        </th>
                        <td mat-cell *matCellDef="let row" [ngClass]="{ highlight: selectedRowIndex == row.id }"
                            (click)="getItemDetails(row)" (contextmenu)="onContextMenu($event, row)">
                            {{ row.nb_maneuvers}}


                        </td>
                    </ng-container>



                    <!-- Progress Column -->
                    <ng-container matColumnDef="eco_score">
                        <th mat-header-cell mat-sort-header *matHeaderCellDef>
                            Score d'économie
                        </th>
                        <td mat-cell *matCellDef="let row" [ngClass]="{ highlight: selectedRowIndex == row.id }"
                            (click)="getItemDetails(row)" (contextmenu)="onContextMenu($event, row)">
                            <circle-progress [percent]="row.eco_score" [showSubtitle]=false [radius]="25"
                            [outerStrokeWidth]="2" [innerStrokeWidth]="1"
                            [outerStrokeColor]="updateColor(row.eco_score)"
                            [innerStrokeColor]="updateColor(row.eco_score)" [animation]="false"
                            [animationDuration]="1" [titleFontSize]="18"></circle-progress>
                        </td>
                    </ng-container>


                    <ng-container matColumnDef="eco_score_tendency">
                        <th mat-header-cell mat-sort-header *matHeaderCellDef>
                            Tendance d'économie
                        </th>
                        <td mat-cell *matCellDef="let row" [ngClass]="{ highlight: selectedRowIndex == row.id }"
                            (click)="getItemDetails(row)">

                            <mat-icon style="color: #4ca846b5;" *ngIf="(row.eco_score_tendency == 1 )">
                                arrow_upward </mat-icon>

                            <mat-icon style="color: #237dbdb0;" *ngIf="(row.eco_score_tendency == 0 )">
                                arrow_forward</mat-icon>

                            <mat-icon style="color: #e15b6b;" *ngIf="(row.eco_score_tendency == -1 )">
                                arrow_downward </mat-icon>
                        </td>
                    </ng-container>


                    <ng-container matColumnDef="tendance_economie_mensuelle">
                        <th mat-header-cell mat-sort-header *matHeaderCellDef>
                            Tendance d'économie mensuelle
                        </th>
                        <td mat-cell *matCellDef="let row" [ngClass]="{ highlight: selectedRowIndex == row.id }"
                            (click)="getItemDetails(row)" (contextmenu)="onContextMenu($event, row)">
                            {{ row.open_issues }}%
                        </td>
                    </ng-container>

                    <!-- Color Column -->
                    <ng-container matColumnDef="diff_eco_score">
                        <th mat-header-cell mat-sort-header *matHeaderCellDef>
                            Diff. d'économie
                        </th>
                        <td mat-cell *matCellDef="let row" [ngClass]="{ highlight: selectedRowIndex == row.id }"
                            (click)="getItemDetails(row)" (contextmenu)="onContextMenu($event, row)">
                            {{ row.diff_eco_score}}
                        </td>
                    </ng-container>

                    <!-- Color Column -->
                    <ng-container matColumnDef="idle_time">
                        <th mat-header-cell mat-sort-header *matHeaderCellDef>
                            Temps d'inactivité
                        </th>
                        <td mat-cell *matCellDef="let row" [ngClass]="{ highlight: selectedRowIndex == row.id }"
                            (click)="getItemDetails(row)" (contextmenu)="onContextMenu($event, row)">
                            {{ row.idle_time}} %
                        </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row (click)="goToBottom(820)" *matRowDef="let row; columns: displayedColumns"
                        (dblclick)="dbClickitem(row.id)"></tr>

                    <!-- Row shown when there is no matching data. -->
                    <tr class="mat-row" *matNoDataRow>
                        <td class="mat-cell" colspan="12">
                          Aucune donnée correspondante à votre recherche
                        </td>
                    </tr>
                </table>



            </div>
            <mat-paginator #paginator [pageSize]="pageSize" (page)="pageEvent = $event"
                [pageSizeOptions]="pageSizeOptions" [showFirstLastButtons]="true">
            </mat-paginator>




        </div>


        <div class="row pr-2">

        </div>

    </div>
    <div class="row pr-3 py-3" style="    padding-left: 78px !important;">

    </div>

    <div class="row rowposition2 pr-1">

        <div class="col-lg-3 col-xl-3 col-md-6 pr-0 py-2" style="  border-radius: 6px">
            <div class="mr-2"
                style="box-shadow: 5.9px 6.8px 15.5px rgba(137, 148, 169, 0.28), -2.8px -2.8px 8px white, inset 3.5px 3.5px 6px rgba(255, 255, 255, 0.15);">
                <ul class="list-group " style="list-style-type: none;">
                    <li class="list-group-item active" style="color: #ffffff">
                        <img src="assets/newImages/vehicule.svg" /> Véhicule
                    </li>
                </ul>

                <div *ngIf="hiddenDetails !=false && tblhidden != 'true'" class="col-12 col-md-3 w-100 my-1  p-2 "
                    style="max-width:100%; word-wrap:break-word;background: #FFFFFF">

                    <div class="row px-2 ">
                        <table class="table table-hover w-100 m-0" style="border-style: hidden;">
                            <thead class="d-none">
                                <tr class="d-none">
                                    <th scope="col">Last</th>
                                    <th scope="col">Handle</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td><b>Nom</b></td>
                                    <td style="max-width:40px; word-wrap:break-word;">{{itemSelect.name}}</td>
                                </tr>




                            </tbody>
                        </table>

                    </div>
                </div>


            </div>



        </div>
        <div class="col-lg-3 col-xl-3 col-md-6 p-0 py-2" style="  border-radius: 6px">
            <div class="mr-2"
                style="box-shadow: 5.9px 6.8px 15.5px rgba(137, 148, 169, 0.28), -2.8px -2.8px 8px white, inset 3.5px 3.5px 6px rgba(255, 255, 255, 0.15);">
                <ul class="list-group ">
                    <li class="list-group-item active" style="color: #ffffff">
                        <img src="assets/newImages/distance.svg" /> Distance
                    </li>
                </ul>
                <div *ngIf="hiddenDetails !=false  && tblhidden != 'true'"
                    class="col-12 col-md-3 w-100 my-1  px-2 py-0 "
                    style="max-width:100%; word-wrap:break-word;background: #FFFFFF">
                    <div class="row px-2 ">

                        <table class="table table-hover w-100 m-0" style="border-style: hidden;">
                            <thead class="d-none">
                                <tr class="d-none">
                                    <th scope="col">Last</th>
                                    <th scope="col">Handle</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td><b>Total</b></td>
                                    <td style="max-width:20px; word-wrap:break-word;">
                                        {{itemSelect.distance_traveled}} Km</td>
                                </tr>
                                <tr>
                                    <td><b>Moyenne / trajet </b></td>
                                    <td style="max-width:20px; word-wrap:break-word;">
                                        {{itemSelect.avg_distance_per_trip}} Km </td>
                                </tr>
                                <tr>
                                    <td><b>Moyenne / jour </b></td>
                                    <td style="max-width:20px; word-wrap:break-word;">
                                        {{itemSelect.avg_distance_per_day}} Km</td>
                                </tr>




                            </tbody>
                        </table>
                    </div>
                </div>

            </div>
        </div>
        <div class="col-lg-3 col-xl-3 col-md-6   p-0 py-2" style="  border-radius: 6px ;">
            <div class="mr-2"
                style="box-shadow: 5.9px 6.8px 15.5px rgba(137, 148, 169, 0.28), -2.8px -2.8px 8px white, inset 3.5px 3.5px 6px rgba(255, 255, 255, 0.15);">
                <ul class="list-group ">
                    <li class="list-group-item active" style="color: #ffffff">
                        <img src="assets/newImages/duree.svg" /> Durée
                    </li>
                </ul>

                <div *ngIf="hiddenDetails !=false  && tblhidden != 'true'"
                    class="col-12 col-md-3 w-100 my-1  px-2 py-0 "
                    style="max-width:100%; word-wrap:break-word;background: #FFFFFF">
                    <div class="row px-2 ">
                        <table class="table table-hover w-100 m-0" style="border-style: hidden;">
                            <thead class="d-none">
                                <tr class="d-none">
                                    <th scope="col">Last</th>
                                    <th scope="col">Handle</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td><b>Total</b></td>
                                    <td style="max-width:40px; word-wrap:break-word;">
                                        {{itemSelect.trip_duration | formatTime}} </td>
                                </tr>
                                <tr>
                                    <td><b>Moyenne / trajet </b></td>
                                    <td style=" word-wrap:break-word;">
                                        {{itemSelect.avg_duration_per_trip | formatTime}} </td>
                                </tr>
                                <tr>
                                    <td><b>Moyenne / jour </b></td>
                                    <td style="max-width:40px; word-wrap:break-word;">
                                        {{itemSelect.avg_duration_per_day | formatTime}} </td>
                                </tr>

                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-lg-3 col-xl-3 col-md-6  p-0 py-2" style="  border-radius: 6px">
            <div class="mr-2"
                style="box-shadow: 5.9px 6.8px 15.5px rgba(137, 148, 169, 0.28), -2.8px -2.8px 8px white, inset 3.5px 3.5px 6px rgba(255, 255, 255, 0.15);">
                <ul class="list-group " style="list-style-type: none;">
                    <li class="list-group-item active" style="color: #ffffff">
                        <img weight="25px" height="25px" src="assets/newImages/activite.svg" /> Activité
                    </li>
                </ul>
                <div *ngIf="hiddenDetails !=false  && tblhidden != 'true'"
                    class="col-12 col-md-3 w-100 my-1  px-2 py-0 "
                    style="max-width:100%; word-wrap:break-word;background: #FFFFFF">

                    <div class="row px-2 ">
                        <table class="table table-hover w-100 m-0" style="border-style: hidden;">
                            <thead class="d-none">
                                <tr class="d-none">
                                    <th scope="col">Last</th>
                                    <th scope="col">Handle</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td><b>Nbr trajets </b></td>
                                    <td style="max-width:40px; word-wrap:break-word;">{{itemSelect.trips}}</td>
                                </tr>
                                <tr>
                                    <td><b>Nbr événement</b></td>
                                    <td style=" word-wrap:break-word;">{{itemSelect.nb_events}}</td>
                                </tr>
                                <tr>
                                    <td><b>Jours actifs </b></td>
                                    <td style="max-width:40px; word-wrap:break-word;">{{itemSelect.active_days}}</td>
                                </tr>
                                <tr>
                                    <td><b>Vitesse moyenne</b></td>
                                    <td style="max-width:20px; word-wrap:break-word;">{{itemSelect.avg_speed}} Km/h</td>
                                </tr>




                            </tbody>
                        </table>

                    </div>
                </div>

            </div>
        </div>
        <div class=" pr-0 py-2 chart-sec" style="  border-radius: 6px;width: 73%;">
            <div class="mr-2 mb-2">
                <ul class="list-group ">
                    <li class="list-group-item active" style="color: #ffffff ;     padding-right: 0px !important;">
                        <div class="row w-100 ">
                            <div class=" col-md-6">
                                Evolution du score de sécurité (%)
                            </div>
                            <div class="col-md-4">

                            </div>
                            <div class="col-md-2" style="text-align: right;     padding-right: 0 !important;">
                                <mat-slide-toggle (click)="goToBottom(1400)" [checked]="myModel"
                                    (change)="showChartEvolutionScoreSecurite()"></mat-slide-toggle>

                            </div>
                        </div>

                    </li>
                </ul>


            </div>




            <apx-chart *ngIf="evolutionScoreSecurite == true" [annotations]="chartOptions3?.annotations"
                [series]="chartOptions3?.series" [chart]="chartOptions3?.chart" [xaxis]="chartOptions3?.xaxis"
                [stroke]="chartOptions3?.stroke" [colors]="chartOptions3?.colors"
                [dataLabels]="chartOptions3?.dataLabels" [legend]="chartOptions3?.legend"
                [markers]="chartOptions3?.markers" [grid]="chartOptions3?.grid" [yaxis]="chartOptions3?.yaxis"
                [title]="chartOptions3?.title" [tooltip]="chartOptions3?.tooltip">
            </apx-chart>

        </div>
        <div class="pr-0 py-2 chart-sec" style="  border-radius: 6px;margin-left: 2%; width: 25%;">
            <div class="mr-2 mb-2">
                <ul class="list-group ">
                    <li class="list-group-item active" style="color: #ffffff  ;padding-right: 0px !important;">
                        <div class="row w-100 ">
                            <div class=" col-md-11">
                                Répartition des scores de sécurité
                            </div>

                            <div class="col-md-1" style="text-align: right;     padding-right: 0 !important;">
                                <mat-slide-toggle [checked]="myModel" (change)="showChartRepartitionScoreSecurite()">
                                </mat-slide-toggle>

                            </div>
                        </div>

                    </li>

                </ul>
            </div>

            <apx-chart *ngIf="repartitionScoreSecurite  == true" [tooltip]="chartOptions2?.tooltips"
                [series]="chartOptions2?.series" [chart]="chartOptions2?.chart" [labels]="chartOptions2?.labels"
                [dataLabels]="chartOptions2?.dataLabels" [title]="chartOptions2?.title" [fill]="chartOptions2?.fill"
                [states]="chartOptions2?.states" [plotOptions]="chartOptions2?.plotOptions"
                [stroke]="chartOptions2?.stroke" [theme]="chartOptions2?.theme" [legend]="chartOptions2?.legend"
                [colors]="chartOptions2?.colors" [tooltip]="chartOptions2?.tooltip"></apx-chart>



        </div>
        <div class="pr-0 py-2 chart-sec" style="  border-radius: 6px;width: 73%;">
            <div class="mr-2 mb-2">
                <ul class="list-group ">
                    <li class="list-group-item active" style="color: #ffffff  ;padding-right: 0px !important;">
                        <div class="row w-100 ">
                            <div class=" col-md-11">
                                Evolution du score d'économie (%)
                            </div>

                            <div class="col-md-1" style="text-align: right;     padding-right: 0 !important;">
                                <mat-slide-toggle [checked]="myModel" (change)="showChartEvolutionScoreEconomie()">
                                </mat-slide-toggle>

                            </div>
                        </div>

                    </li>
                </ul>
            </div>

            <apx-chart *ngIf="evolutionScoreEconomie == true" [annotations]="chartOptions5?.annotations"
                [series]="chartOptions5?.series" [chart]="chartOptions5?.chart" [xaxis]="chartOptions5?.xaxis"
                [stroke]="chartOptions5?.stroke" [colors]="chartOptions5?.colors"
                [dataLabels]="chartOptions5?.dataLabels" [legend]="chartOptions5?.legend"
                [markers]="chartOptions5?.markers" [grid]="chartOptions5?.grid" [yaxis]="chartOptions5?.yaxis"
                [title]="chartOptions5?.title" [tooltip]="chartOptions5?.tooltip">
            </apx-chart>
        </div>
        <div class="p-0 py-2 chart-sec" style="  border-radius: 6px;width: 25%;margin-left: 2%;">
            <div class="mr-2 mb-2">
                <ul class="list-group ">
                    <li class="list-group-item active" style="color: #ffffff  ;padding-right: 0px !important;">
                        <div class="row w-100 ">
                            <div class=" col-md-11">
                                Répartition des scores d'économie
                            </div>

                            <div class="col-md-1" style="text-align: right;     padding-right: 0 !important;">
                                <mat-slide-toggle [checked]="myModel" (change)="showChartRepartitionScoreEconomie()">
                                </mat-slide-toggle>
                            </div>
                        </div>

                    </li>

                </ul>
            </div>




            <apx-chart *ngIf="repartitionScoreEconomie  == true" [tooltip]="chartOptions4?.tooltips"
                [series]="chartOptions4?.series" [chart]="chartOptions4?.chart" [labels]="chartOptions4?.labels"
                [dataLabels]="chartOptions4?.dataLabels" [title]="chartOptions4?.title" [fill]="chartOptions4?.fill"
                [states]="chartOptions4?.states" [plotOptions]="chartOptions4?.plotOptions"
                [stroke]="chartOptions4?.stroke" [theme]="chartOptions4?.theme" [legend]="chartOptions4?.legend"
                [colors]="chartOptions4?.colors" [tooltip]="chartOptions4?.tooltip"></apx-chart>






        </div>



        <div class="col-12 col-md-12 chart-sec  pr-0  w-100" style="  border-radius: 6px">
            <div class="mr-2 my-2">
                <ul class="list-group ">
                    <li class="list-group-item active" style="color: #ffffff  ;padding-right: 0px !important;">
                        <div class="row w-100 ">
                            <div class=" col-md-8">
                                Relation entre le score de sécurité et d'économie
                            </div>
                            <div class="col-md-2">

                            </div>
                            <div class="col-md-2" style="text-align: right;     padding-right: 0 !important;">
                                <mat-slide-toggle [checked]="myModel" (change)="showChartRelationSecuriteEconomie()">
                                </mat-slide-toggle>
                            </div>
                        </div>
                    </li>

                </ul>
            </div>

            <apx-chart *ngIf="relationSecuriteEconomie  == true" [tooltip]="chartOptions?.tooltips"
                [annotations]="chartOptions?.annotations" [series]="chartOptions?.series" [chart]="chartOptions?.chart"
                [xaxis]="chartOptions?.xaxis" [stroke]="chartOptions?.stroke" [colors]="chartOptions?.colors"
                [dataLabels]="chartOptions?.dataLabels" [legend]="chartOptions?.legend"
                [markers]="chartOptions?.markers" [grid]="chartOptions?.grid" [yaxis]="chartOptions?.yaxis"
                [title]="chartOptions?.title">
            </apx-chart>
        </div>

        <div class="col-12 col-md-12 chart-sec pr-0 w-100   " style="  border-radius: 6px">
            <div #ContainerRef class="mr-2 mt-2 mb-5   ">
                <ul class="list-group ">
                    <li class="list-group-item active" style="color: #ffffff  ;padding-right: 0px !important;">
                        <div class="row w-100 ">
                            <div class=" col-md-6">
                                Répartition des types d'évènement
                            </div>
                            <div class="col-md-4">

                            </div>
                            <div class="col-md-2" style="text-align: right;     padding-right: 0 !important;">
                                <mat-slide-toggle [checked]="myModel" (change)="showChartTypeEvenement()">
                                </mat-slide-toggle>
                            </div>
                        </div>
                    </li>


                </ul>
            </div>
            <apx-chart *ngIf="typeEvenement == true"
            [view]="[ContainerRef.offsetWidth,400]"
                [colors]="chartOptionds.colors"
                [series]="chartOptionds.series"
                [chart]="chartOptionds.chart"
                [xaxis]="chartOptionds.xaxis"
                [title]="chartOptionds.title"
                [markers]="chartOptionds.markers"
                [showGridLines]="false"  [barPadding]="50"
                [xAxis]="true" [yAxis]="true" [gradient]="false" style="font-weight: 800;"
                [showYAxisLabel]="true"  [showXAxisLabel]="true" [legendPosition]="'below'"
            ></apx-chart>
            <!-- <ngx-charts-bar-vertical *ngIf="typeEvenement == true" [customColors]="customColors" [showGridLines]="false"
                [barPadding]="50" [view]="[ContainerRef.offsetWidth,400]" [results]="reposRepartitionTpEvents"
                [xAxisLabel]="'Types'" [legendTitle]="'Types des évènements'" [yAxisLabel]="'Value (%)'"
                [legend]="false" [legendPosition]="'below'" [showXAxisLabel]="true" [showYAxisLabel]="true"
                [xAxis]="true" [yAxis]="true" [gradient]="false">


                <ng-template #tooltipTemplate let-model="model">
                    fields are series/name/value
                    <div class="tt">

                        <p class="pt-3"><b>Evénement :</b> {{ model.name }}</p>
                        <hr style="background-color: #ffffff;"> <i class="fas fa-car-crash fa-2x    "></i> <b
                            style="font-size: 20px;"> {{ model.value }} %</b>
                    </div>
                </ng-template>
            </ngx-charts-bar-vertical> -->



        </div>
    </div>
</div>
